import { alpha, Backdrop, styled, useTheme } from "@mui/material";

import SpinAnimation from "../../../assets/lottie/fill_cycle_spin.json";
import LottieInner from "react-lottie";
import { progressLottieOptions } from "../../../utils/lottieUtils";
import { create } from "zustand";

interface BearState {
  open: boolean;
  title: string;
  subtitle: string;
}

const useOverlay = create<BearState>((set) => ({
  open: false,
  title: "",
  subtitle: "",
}));

// @ts-ignore
const Lottie = LottieInner.default
  ? // @ts-ignore
    LottieInner.default
  : LottieInner;

const BackdropContent = styled("div")(({ theme }) => ({
  maxWidth: 250,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 7,
  ".spinner": {
    width: 71,
    height: 71,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 4,
  },
  ".title": {
    color: theme.vars.palette.text.primary,
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
  },
  ".subtitle": {
    color: theme.vars.palette.text.primary,
    textAlign: "center",
    fontSize: 14,
    fontWeight: 500,
  },
}));

const LoadingOverlay = () => {
  const theme = useTheme();
  const { open, title, subtitle } = useOverlay();
  return (
    <Backdrop
      sx={{
        color: (theme) => theme.vars.palette.text.primary,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.95),
      }}
      open={open}
    >
      <BackdropContent>
        <div className="spinner">
          <div style={{ position: "absolute" }}>
            <Lottie
              options={progressLottieOptions(theme, SpinAnimation)}
              isClickToPauseDisabled
              width={160}
              height={160}
            />
          </div>
        </div>
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
      </BackdropContent>
    </Backdrop>
  );
};

LoadingOverlay.open = (title: string, subtitle: string) => {
  useOverlay.setState({ open: true, title, subtitle });
};

LoadingOverlay.close = () => {
  useOverlay.setState({ open: false, title: "", subtitle: "" });
};

export default LoadingOverlay;
